<template>
	<Popup
		v-model="selfDisplay"
		title="查看"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>标题</span>
				<el-input :value="title" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>副标题</span>
				<el-input :value="subTitle" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>上传图片</span>
				<div class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="post" alt="" style="">
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>分类</span>
				<el-select :value="type" disabled style="width: 100%;">
					<el-option v-for="v in types" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>类型</span>
				<el-select :value="category" disabled style="width: 100%;">
					<el-option v-for="v in appArticleCategory" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #F56C6C;">*</span>主商品：</span>
				<el-tag :disable-transitions="false" style="height: 36px;margin: 0 10px 10px 0;line-height: 34px;">{{ product.name }}</el-tag>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #F56C6C;">*</span>推荐商品：</span>
				<el-tag v-for="v in recommends" :key="v.id" :disable-transitions="false" style="height: 36px;margin: 0 10px 10px 0;line-height: 34px;">{{ v.name }}</el-tag>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>内容</span>
				<editor v-model="content" :enableEditor="false"></editor>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js';
	import { mapState } from 'vuex';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			types: {
				type: Array,
				default() { return []; }
			},
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				title: '',
				subTitle: '',
				post: '',
				type: '',
				category: '',
				product: {
					id: '',
					name: ''
				},
				recommends: [],
				content: ''
			}
		},
		computed: {
			...mapState([
				'appArticleCategory'
			])
		},
		methods: {
			// 获取文章详情
			getArticleInfo() {
				const that = this;
				that.loading = true;
				Api.viewAppArticle(that.obj.id).then((res) => {
					if (res.data.success) {
						let data = res.data.data;
						let recommends = [];
						data.postGoods.forEach(v => {
							recommends.push({
								id: v.goodsId,
								name: v.goodsName
							});
						});
						that.loading = false;
						that.title = data.postTitle;
						that.subTitle = data.postSummaryContent;
						that.post = data.postImg;
						that.type = data.catId;
						that.category = data.postTag;
						that.product.name = data.postGoodsMain.goodsName;
						that.recommends = recommends;
						that.content = data.postContent;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.getArticleInfo();
				} else {
					this.loading = false;
					this.title = '';
					this.subTitle = '';
					this.post = '';
					this.type = '';
					this.category = '';
					this.product = {
						id: '',
						name: ''
					};
					this.recommends = [];
					this.content = '';
				}
			}
		}
	}
</script>

<style>
</style>
